// DokuIntegration.js
const ClickToPay = require('./ClickToPay');

class DokuIntegration extends ClickToPay {
  async handlePayment({ payment_url, reference_number, ws_url }) {
    // Doku-specific logic: Call loadJokulCheckout with the payment URL from the response
    if (payment_url) {
      loadJokulCheckout(payment_url);
      this.fieldsService.disableEnableFields(false);
    } else {
      throw new Error('Doku integration: payment_url not found in response');
    }

    // Handle WebSocket connection if ws_url and reference_number are present
    await this.handleWebSocket({
      ws_url: ws_url,
      reference_number: reference_number,
    });
  }

  // Implement checkDependency for Doku
  checkDependency() {
    return typeof loadJokulCheckout === 'function';
  }
}

module.exports = DokuIntegration;
